module.exports = __webpack_public_path__ + "media/images/weather/168_night-9dd04a7e8c6f4ffeb0f5a26904b77052.png";